export const providingKey =
  'descriptions.admin-portal.events.details.basic-info.providing';
